import React, { useEffect, useRef } from 'react'

const scrollAnchorStyle = { opacity: 0, height: 0 }

interface ScrollAnchorProps {
  autoScroll?: boolean
  block?: ScrollLogicalPosition
  testId: string
}

const ScrollAnchor = ({
  autoScroll = false,
  block = 'end',
  testId,
}: ScrollAnchorProps) => {
  const scrollerRef = useRef<HTMLDivElement>(null)
  const hasScrolledRef = useRef(false)

  useEffect(() => {
    if (!autoScroll) {
      hasScrolledRef.current = false
      return
    }

    if (scrollerRef.current && !hasScrolledRef.current) {
      hasScrolledRef.current = true
      // Double-rAF ensures content has fully rendered before scrolling
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollerRef.current?.scrollIntoView({ block, behavior: 'auto' })
        })
      })
    }
  }, [autoScroll, block])

  return (
    <div
      data-testid={`${testId}-scroll-anchor`}
      ref={scrollerRef}
      style={scrollAnchorStyle}
    />
  )
}

export default ScrollAnchor
